import React from "react";
import { createHeader } from "./utils/createHeader";
import { rows, TRowData } from "./tableDataTemp";
import { FlexCenter } from "../../../layout/FlexCenter/FlexCenter";
import { Spacing } from "../../../layout/Spacing/Spacing";
import { SpacingCustom } from "../../../layout/Spacing/SpacingCustom";
import IconComponent from "../../../shared/IconComponents/IconComponent";
import { TextCustom } from "../../../ui/TextCustom";

const iconMap: Record<string, string> = {
    change: 'change_dashboard',
    adjusment: 'adjusment_dashboard',
    new: 'new_dashboard',
    deleted: 'deleted_dashboard'
}

export const DashboardConfigTable = () => {

    const headers = createHeader(rows[0]);
    
    return (
<SpacingCustom paddingLeft={3.5} paddingRight={3.5}>

<table className="dashboard-table">
    <thead className="dashboard-table__header">

        <tr className="dashboard-table__header--row-first dashboard-table__header--row-item">
            {headers.map((header) => (
                <th className="dashboard-table__header--cell-first dashboard-table__header--cell-item" colSpan={header.columns.length} key={header.group}>
                    <FlexCenter>
                        <Spacing paddingSpacing="m" marginSpacing="none">
                            <TextCustom size={1.2} weight={600} color="dark" >{header.group}</TextCustom>
                        </Spacing>
                    </FlexCenter>
                </th>
            ))}
        </tr>

        <tr className="dashboard-table__header--row-second dashboard-table__header--row-item">
            {
                headers.flatMap((header) =>
                    header.columns.map((col) => (
                        <th className="dashboard-table__header--cell-second dashboard-table__header--cell-item" key={col} >
                            <Spacing paddingSpacing="m" marginSpacing="none">
                                {
                                    iconMap[col]
                                    ?
                                    <SpacingCustom paddingTop={.3}>
                                        <IconComponent size={2} iconName={iconMap[col]}/>
                                    </SpacingCustom>
                                    :
                                    `${col[0].toUpperCase()}${col.slice(1)}`
                                }
                            </Spacing>
                            
                        </th>
                    ))
                )
            }
        </tr>

    </thead>

    <tbody className="dashboard-table__body">
        {
            rows.map((row, rowIndex) => {
                let color = "white";
                if(row.Status?.columns.change === true && row.Status?.columns.deleted === true) color = "orange";
                if(row.Status?.columns.change === true && row.Status?.columns.adjusment === true) color = "green";
                if(row.Status?.columns.change === true && row.Status?.columns.new === true) color = "blue";
                else if(row.Status?.columns && Object.values(row.Status.columns).every((val) => val === false)) color = "white";
                
                return <tr className={`dashboard-table__body--row dashboard-table__body--row-${color}`} key={rowIndex}>
                    {
                        headers.flatMap((header) =>
                            header.columns.map((col, idx) => 
                                {
                                    const cellValue = (row[header.tableProp as keyof TRowData]?.columns as Record<string, boolean>)?.[col];
                 

                                    return (
                                        <td className={`dashboard-table__body--cell dashboard-table__body--cell-${color} ${typeof cellValue === 'boolean' && 'dashboard-table__body--cell-white'} dashboard-table__body--cell-${typeof cellValue === 'boolean' ? 'center' : 'left'}`} key={idx}>
                                            {
                                                (typeof cellValue === 'boolean')
                                                ?
                                                <SpacingCustom paddingTop={.3}>
                                                    <IconComponent size={1.4} iconName={`${cellValue ? 'checker_dashboard' : 'empty_dashboard'}`}/>
                                                </SpacingCustom>
                                                :
                                                <div className={`dashboard-table__body--cell-label dashboard-table__body--cell-label-${color}`}>
                                                    {cellValue}
                                                </div>
                                            }
                                        </td>
                                    )
                                }
                            )
                        )
                    }
                </tr>
            })
        }
    </tbody>
</table>
</SpacingCustom>
    )
}